/* ws-signup-popup.js - email signup popup + teaser pill (snippets/ws-signup-popup.liquid).

   Display rules (design handoff):
   - The teaser pill shows first, then the popup takes over after 3s or at 40% scroll,
     whichever comes first. Dismissing the pill in those 3s counts as "no thanks".
   - Never over an editor: while one is open the popup waits (and steps aside if an
     editor opens on top of it), then gets a fresh 3s once the editor closes.
   - Closed without subscribing: no auto-open for 14 days; the teaser pill shows on
     later page views instead, until the visitor dismisses it (per session).
   - Subscribed, arrived from a Klaviyo email (_kx), or already known to Klaviyo:
     neither the popup nor the teaser ever shows.

   Subscribing goes through Klaviyo's Client API (public key only) to the Email List,
   which starts the Welcome Series. The code is also applied to the Shopify session
   (/discount/<code>) so it is already on the cart at checkout. */
(function () {
  var script = document.currentScript;
  var overlay = document.getElementById('wsp-overlay');
  var teaser = document.getElementById('wsp-teaser');
  if (!script || !overlay || !teaser) return;

  var COMPANY = script.dataset.company, LIST = script.dataset.list;
  var CODE = script.dataset.code, SOURCE = script.dataset.source;
  var KEY_DISMISSED = 'ws_popup_dismissed_at', KEY_SUBSCRIBED = 'ws_popup_subscribed';
  var KEY_KNOWN = 'ws_popup_known', KEY_TEASER = 'ws_teaser_dismissed';
  var SNOOZE_MS = 14 * 24 * 60 * 60 * 1000, DELAY_MS = 3000, SCROLL_AT = 0.4;
  // Body classes the editor launchers set while an editor (or the product picker) is open.
  var EDITOR_CLASSES = ['ws-modal-open', 'wse-open', 'wsmap-open', 'wsc-pick-open'];
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  var $ = function (id) { return document.getElementById(id); };
  var formView = $('wsp-form-view'), successView = $('wsp-success-view');
  var form = $('wsp-form'), input = $('wsp-email'), error = $('wsp-error'), submit = $('wsp-submit');
  var copyBtn = $('wsp-copy');
  var lastFocus = null, autoTimer = null, pending = false;

  function get(store, k) { try { return window[store].getItem(k); } catch (e) { return null; } }
  function set(store, k, v) { try { window[store].setItem(k, v); } catch (e) {} }

  // Reading offsetWidth commits the un-hidden start state, so the class change transitions.
  function show(el, cls) { el.hidden = false; void el.offsetWidth; el.classList.add(cls); }
  function hide(el, cls) { el.classList.remove(cls); setTimeout(function () { if (!el.classList.contains(cls)) el.hidden = true; }, 200); }

  function isOpen() { return !overlay.hidden && overlay.classList.contains('is-open'); }
  function subscribed() { return get('localStorage', KEY_SUBSCRIBED) === '1'; }

  function showTeaser() {
    if (subscribed() || get('sessionStorage', KEY_TEASER) === '1') return;
    show(teaser, 'is-visible');
  }

  function open() {
    if (isOpen()) return;
    stopAuto();
    lastFocus = document.activeElement;
    hide(teaser, 'is-visible');
    show(overlay, 'is-open');
    document.documentElement.classList.add('wsp-locked');
    setTimeout(function () {
      var target = successView.hidden ? input : successView.querySelector('h2');
      if (target) target.focus({ preventScroll: true });
    }, 60);
  }

  function close(toTeaser) {
    if (overlay.hidden) return;
    hide(overlay, 'is-open');
    document.documentElement.classList.remove('wsp-locked');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    if (!subscribed()) {
      set('localStorage', KEY_DISMISSED, String(Date.now()));
      if (toTeaser) setTimeout(showTeaser, 200);
    }
  }

  function editorOpen() {
    return EDITOR_CLASSES.some(function (c) { return document.body.classList.contains(c); });
  }

  // ---- Auto-open: 3s or 40% scroll, whichever first; held while an editor is open ----
  function autoOpen() {
    stopAuto();
    if (editorOpen()) { pending = true; return; }
    open();
  }
  function onScroll() {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    if (max > 0 && window.scrollY / max >= SCROLL_AT) autoOpen();
  }
  function stopAuto() {
    clearTimeout(autoTimer);
    autoTimer = null;
    window.removeEventListener('scroll', onScroll);
  }
  function startAuto() {
    showTeaser();
    autoTimer = setTimeout(autoOpen, DELAY_MS);
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // An editor opening steps the popup aside (not a dismissal); closing it resumes the wait.
  new MutationObserver(function () {
    if (editorOpen()) {
      if (isOpen()) {
        hide(overlay, 'is-open');
        document.documentElement.classList.remove('wsp-locked');
        pending = true;
      }
    } else if (pending && !subscribed()) {
      pending = false;
      startAuto();
    }
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  // ---- Wiring ----
  overlay.querySelectorAll('[data-wsp-close]').forEach(function (b) {
    b.addEventListener('click', function () { close(true); });
  });
  overlay.querySelector('[data-wsp-done]').addEventListener('click', function () { close(false); });
  overlay.addEventListener('click', function (e) { if (e.target === overlay) close(true); });
  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { e.preventDefault(); close(true); return; }
    if (e.key !== 'Tab') return;
    // Focus trap: cycle through the visible controls in the card.
    var items = Array.prototype.filter.call(
      overlay.querySelectorAll('button, a[href], input'),
      function (el) { return !el.disabled && el.offsetParent !== null; }
    );
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || !overlay.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  $('wsp-teaser-open').addEventListener('click', open);
  $('wsp-teaser-x').addEventListener('click', function () {
    set('sessionStorage', KEY_TEASER, '1');
    hide(teaser, 'is-visible');
    if (autoTimer || pending) {
      // Dismissed before the popup had its turn: same as "No thanks".
      stopAuto();
      pending = false;
      set('localStorage', KEY_DISMISSED, String(Date.now()));
    }
  });

  function setError(msg) {
    error.textContent = msg || '';
    error.hidden = !msg;
    input.setAttribute('aria-invalid', msg ? 'true' : 'false');
  }
  input.addEventListener('input', function () { if (!error.hidden) setError(''); });

  function subscribe(email) {
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(COMPANY), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
      body: JSON.stringify({ data: {
        type: 'subscription',
        // No `subscriptions` block on the profile: revision 2024-10-15 rejects it with a
        // 400. The endpoint itself records email marketing consent for the list.
        attributes: {
          custom_source: SOURCE,
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: { list: { data: { type: 'list', id: LIST } } }
      } })
    }).then(function (r) { if (!r.ok) throw new Error('Klaviyo ' + r.status); });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = input.value.trim();
    if (!EMAIL_RE.test(email)) { setError('Please enter a valid email address.'); input.focus(); return; }
    setError('');
    submit.disabled = true;
    subscribe(email).then(function () {
      set('localStorage', KEY_SUBSCRIBED, '1');
      // Let Klaviyo's onsite tracking (browse/cart abandonment) recognise this visitor.
      try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); } catch (err) {}
      // Put the code on the Shopify session so checkout already has it.
      fetch('/discount/' + encodeURIComponent(CODE), { credentials: 'same-origin' }).catch(function () {});
      formView.hidden = true;
      successView.hidden = false;
      var h = successView.querySelector('h2');
      h.setAttribute('tabindex', '-1');
      h.focus({ preventScroll: true });
    }).catch(function () {
      setError('Something went wrong. Please try again.');
    }).then(function () { submit.disabled = false; });
  });

  copyBtn.addEventListener('click', function () {
    var code = $('wsp-code').textContent;
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).catch(function () {});
    copyBtn.textContent = 'Copied';
  });

  // ---- Who sees it ----
  if (/[?&]_kx=/.test(location.search)) set('localStorage', KEY_KNOWN, '1');
  if (subscribed() || get('localStorage', KEY_KNOWN) === '1') return;

  function knownToKlaviyo() {
    return new Promise(function (resolve) {
      var k = window.klaviyo;
      if (!k || typeof k.isIdentified !== 'function') return resolve(false);
      var t = setTimeout(function () { resolve(false); }, 2000);
      Promise.resolve(k.isIdentified()).then(function (v) { clearTimeout(t); resolve(!!v); }, function () { clearTimeout(t); resolve(false); });
    });
  }

  knownToKlaviyo().then(function (known) {
    if (known) return;
    var dismissedAt = Number(get('localStorage', KEY_DISMISSED) || 0);
    if (dismissedAt && Date.now() - dismissedAt < SNOOZE_MS) showTeaser();
    else startAuto();
  });

  window.WSPopup = { open: open, close: close };
})();
